import { SavedProfilesDetailPage } from '@/features/saved-profiles';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/workspace/$workspaceId/saved-profiles/$listId/')({
  component: SavedProfilesDetailPage,
});
